import Icon from '../components/Icon.vue'

Icon.register({
  'grip-lines-vertical': {
    width: 256,
    height: 512,
    paths: [
      {
        d: 'M96 496c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-480c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v480zM224 496c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-480c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v480z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/grip-lines-vertical.js
// module id = 1413
// module chunks = 0